import {CareTask} from '../backend/interfaces/care-task';
import {EntityPendingTask} from '../backend/interfaces/entity-pending-task';
import {BackendApiManager} from '../managers/backend-api';
import {Logger} from '../utils/managers/logger';
import {PaginatedArrayResponse} from './interfaces/paginated-array-response';

export class EntityPendingTasksRepository {
  // Singleton Instance
  private static _instance: EntityPendingTasksRepository;

  // Private
  private logger: Logger;

  static get instance(): EntityPendingTasksRepository {
    if (!this._instance) {
      this._instance = new EntityPendingTasksRepository();
    }
    return this._instance;
  }

  constructor() {
    // Create Logger
    this.logger = new Logger('EntityPendingTasksRepository');
  }

  // Get pending tasks for an entity
  public async getPendingTasks(
    entityId: string,
    limit?: number,
    skip?: number
  ): Promise<PaginatedArrayResponse<{pendingCareTask: EntityPendingTask; careTask: CareTask}>> {
    const response = await BackendApiManager.instance.get<
      {pendingCareTask: EntityPendingTask; careTask: CareTask}[]
    >(`/entities/${entityId}/pending-care-tasks?limit=${limit}&skip=${skip}`);

    return {
      data: response.data,
      totalCount: parseInt(response.headers['x-total-count'] || '', 10),
    };
  }
}
